module.exports = __webpack_public_path__ + "static/img/AX.f0b28420.jpg";